module.exports = "/assets/5015b5c757e8f0116b3ca148bd13ea71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/menu/flight.png
// module id = 229
// module chunks = 0